import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import './typography.css'

const Caption = ({ children, className }) => <p className={cn('Caption', className)}>{children}</p>

Caption.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default Caption
